/* eslint-disable */
'use-strict';

// import { Buffer } from 'node:buffer'; // future node version; V14 is static
import Currency from "currency.js";
import axios    from "axios";
import Moment   from "moment";
import FMT      from "./formattingLib.js";
// import GeneralService from '@/services/GeneralService';

var EPSON        = {},
    printer      = null,
    printerIp    = "",
    printerName  = "local_printer",
    epos         = null,
    isPrintError = false,
    isPrinting   = false,
    sendPromiseResolve = null,
    sendPromiseReject = null,
    printerConnectionFailed = false, // Flag to prevent retry loops
    printerErrorCount = 0, // Track consecutive errors
    isAuthenticated = false, // Track authentication status
    printerConfigured = false; // Track if a printer IP/name is configured

function addHeader(ticket, order) {

  ticket.addTextSize(1, 1);
  ticket.addText("-----------------------------------\n\n");
  ticket.addText(Moment(order.orderDate).format("dddd, DD-MMM") + "\n");
  ticket.addText("-----------------------------------\n\n");

  return ticket;
}

FMT.init();

export default EPSON;

(function() {

  // Authenticate with printer using iframe to establish session (like iCare does)
  // This avoids CORS issues by establishing a browser session that XMLHttpRequest can use
  EPSON.authenticate = async (ip) => {
    if(!ip) {
      return false;
    }
    
    return new Promise((resolve) => {
      try {
        console.log(`Authenticating with printer at ${ip} using iframe session...`);
        
        // Create a hidden iframe to authenticate and establish session cookies
        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.style.width = '0';
        iframe.style.height = '0';
        iframe.style.border = 'none';
        iframe.style.position = 'absolute';
        iframe.style.left = '-9999px';
        
        // Use URL with credentials - browser will handle Basic Auth and establish session
        const authUrl = `http://epson:epson@${ip}/`;
        iframe.src = authUrl;
        
        let authenticated = false;
        const timeout = setTimeout(() => {
          if(!authenticated) {
            console.log(`Printer authentication timeout - session may still be established`);
            try {
              if(iframe.parentNode) {
                document.body.removeChild(iframe);
              }
            } catch(e) {
              // Iframe might already be removed
            }
            resolve(true); // Proceed - session might be established
          }
        }, 3000); // 3 second timeout
        
        iframe.onload = () => {
          authenticated = true;
          clearTimeout(timeout);
          console.log(`Printer authentication iframe loaded - session established`);
          // Keep iframe for a moment to ensure session cookie is set
          setTimeout(() => {
            try {
              if(iframe.parentNode) {
                document.body.removeChild(iframe);
              }
            } catch(e) {
              // Iframe might already be removed
            }
          }, 500);
          resolve(true);
        };
        
        iframe.onerror = () => {
          authenticated = true;
          clearTimeout(timeout);
          console.log(`Printer authentication iframe error - but session may be established`);
          try {
            if(iframe.parentNode) {
              document.body.removeChild(iframe);
            }
          } catch(e) {
            // Iframe might already be removed
          }
          resolve(true); // Proceed anyway - session might be established
        };
        
        document.body.appendChild(iframe);
        
      } catch(error) {
        console.error(`Printer authentication error:`, error);
        resolve(true); // Proceed anyway
      }
    });
  };

  EPSON.init = async (ip, printerNameParam = "local_printer") => {
    printerIp = ip;
    printerName = printerNameParam || "local_printer";

    // No IP configured: mark printer as not available and skip any auth/connection work
    if(!ip) {
      printerConfigured   = false;
      isAuthenticated     = false;
      epos                = null;
      printerConnectionFailed = false;
      printerErrorCount   = 0;
      return true;
    }

    // We have an IP, so consider the printer configured
    printerConfigured = true;

    try {
      // Use HTTP to avoid SSL certificate issues
      const protocol = 'http';
      
      // Create printer URL - authentication will be via iframe session (not headers)
      // This avoids CORS issues - the iframe establishes a session cookie that XMLHttpRequest uses
      printer = `${protocol}://${printerIp}/cgi-bin/epos/service.cgi?devid=${printerName}&timeout=60000`;
      epos    = new epson.ePOSPrint(printer);
      
      console.log(`ePOS Created using ${protocol.toUpperCase()} protocol`, epos);
      
      // Authenticate with printer using iframe (establishes session cookies)
      // This runs asynchronously and doesn't block initialization
      // The session cookie will be used automatically by XMLHttpRequest (no CORS issues)
      EPSON.authenticate(ip).then((success) => {
        if(success) {
          console.log(`Printer authentication session established for ${ip}`);
          isAuthenticated = true;
        } else {
          console.warn(`Printer authentication may have failed for ${ip}`);
          isAuthenticated = false;
        }
      }).catch((error) => {
        console.error(`Printer authentication error for ${ip}:`, error);
        isAuthenticated = false;
      });
      
      // Mark as configured (authentication happens in background)
      isAuthenticated = true;
      
      // Don't open the connection yet - we'll open it only when we need to print
      // This prevents infinite retry loops if the printer is not available


    } catch(error) {
      console.log("EPSON.init error:" , error.message);
      printerConfigured = false;
      isAuthenticated   = false;
      return false;
    }

    epos.onreceive = async (res) => {
      console.log("onreceive", JSON.stringify(res, null, 2));
      if(!res.success) {
        isPrintError = true;
        isPrinting   = false;
        console.log("No Joy:", JSON.stringify(res, null, 2));
        // Any printer error should invalidate our auth/session flag;
        // a later print will be allowed to trigger re-auth if needed.
        isAuthenticated = false;

        const error = new Error(`Printer error at ${printerIp}: ${res.code || 'Unknown error'}. ${res.status || ''}`);
        if(sendPromiseReject) {
          sendPromiseReject(error);
          sendPromiseReject = null;
          sendPromiseResolve = null;
        }
        // Close the printer connection on error to stop retry loop
        printerConnectionFailed = true;
        printerErrorCount++;
        if(epos) {
          try {
            if(epos.close) {
              epos.close();
            } else {
              epos.enabled = false;
            }
            console.log("Printer connection closed due to error");
          } catch(closeError) {
            console.error("Error closing printer connection:", closeError);
            if(epos) epos.enabled = false;
          }
        }
        
        // Emit notification event for UI
        if(typeof window !== 'undefined' && window.dispatchEvent) {
          window.dispatchEvent(new CustomEvent('printer-error', { 
            detail: { 
              message: `Printer error at ${printerIp}: ${res.code || 'Unknown error'}`,
              printerIp: printerIp,
              errorCount: printerErrorCount
            } 
          }));
        }
      } else {
        if(isPrinting) {
          isPrinting = false;
          if(sendPromiseResolve) {
            sendPromiseResolve();
            sendPromiseResolve = null;
            sendPromiseReject = null;
          }
          // Reset error counters on successful print
          printerConnectionFailed = false;
          printerErrorCount = 0;
          isAuthenticated = true; // Mark as authenticated on success
          
          // Close the printer connection after successful print to stop status polling
          // We'll reopen it on the next print job
          if(epos && epos.close) {
            try {
              epos.close();
              console.log("Printer connection closed after successful print");
            } catch(closeError) {
              console.error("Error closing printer connection:", closeError);
            }
          }
        }
      }
    }
    
    epos.onerror = (error) => {
      console.error("Printer connection error:", error);
      isPrintError = true;
      isPrinting = false;
      printerConnectionFailed = true;
      printerErrorCount++;
      // Invalidate authentication so a future print can attempt re-auth
      isAuthenticated = false;
      
      // Immediately close the printer connection to stop the retry loop
      if(epos) {
        try {
          // Force close by setting enabled to false and clearing intervals
          if(epos.close) {
            epos.close();
          } else {
            // Fallback: manually disable if close method doesn't work
            epos.enabled = false;
            if(epos.intervalid) {
              clearTimeout(epos.intervalid);
              delete epos.intervalid;
            }
            if(epos.intervalxhr) {
              epos.intervalxhr.abort();
              delete epos.intervalxhr;
            }
          }
          console.log("Printer connection forcefully closed to stop retry loop");
        } catch(closeError) {
          console.error("Error closing printer connection:", closeError);
          // Force disable even if close fails
          if(epos) {
            epos.enabled = false;
          }
        }
      }
      
      // Build a more descriptive error message
      let errorMsg = `Connection error to printer at ${printerIp}.`;
      if(error && error.status !== undefined) {
        errorMsg += ` Status: ${error.status}`;
      }
      if(error && error.responseText) {
        errorMsg += ` Response: ${error.responseText}`;
      }
      
      // Check for CORS or authentication errors
      if(error && error.status === 0) {
        errorMsg += ` This may be a CORS or authentication issue. The printer may require you to log in via browser first to establish a session. Try opening http://${printerIp} in a browser, log in with username 'epson' and password 'epson', then try printing again.`;
      } else {
        errorMsg += ` Please check printer is powered on and connected to the network.`;
      }
      
      const err = new Error(errorMsg);
      if(sendPromiseReject) {
        sendPromiseReject(err);
        sendPromiseReject = null;
        sendPromiseResolve = null;
      }
      
      // Emit notification event for UI
      if(typeof window !== 'undefined' && window.dispatchEvent) {
        window.dispatchEvent(new CustomEvent('printer-error', { 
          detail: { 
            message: errorMsg,
            printerIp: printerIp,
            errorCount: printerErrorCount
          } 
        }));
      }
    }

    return true;
  }

  EPSON.startTicket = () => {
    //Create an ePOS-Print Builder object

    let ticket = new epson.ePOSBuilder();

    //Create a print document
    ticket.addTextLang('en')
    ticket.addTextSmooth(true);
    ticket.addTextFont(ticket.FONT_A);
    ticket.addTextAlign(ticket.ALIGN_CENTER);
    return ticket;
  }

  EPSON.printList = async (list, printerIpParam = null, printerNameParam = null) => {
    // Auto-initialize if printer is not initialized
    if(!epos) {
      // Use provided parameters or fall back to stored values
      const ipToUse = printerIpParam || printerIp;
      const nameToUse = printerNameParam || printerName;
      
      if(!ipToUse) {
        const error = new Error(`Printer not configured. Please check printer settings.${printerIp ? ` (Last known IP: ${printerIp})` : ' (No printer IP configured)'}`);
        console.error("EPSON.printList error:", error.message);
        throw error;
      }
      
      console.log(`Printer not initialized, attempting auto-initialization with IP: ${ipToUse}...`);
      try {
        const initResult = await EPSON.init(ipToUse, nameToUse);
        if(!initResult || !epos) {
          const error = new Error(`Failed to initialize printer at ${ipToUse}. Please check printer connection.`);
          console.error("EPSON.printList auto-init failed:", error.message);
          throw error;
        }
        console.log(`Printer auto-initialized successfully at ${ipToUse}`);
      } catch(error) {
        console.error("EPSON.printList auto-init error:", error.message);
        throw new Error(`Failed to initialize printer at ${ipToUse}: ${error.message}`);
      }
    }

    // Only open if we haven't had recent connection failures
    // Reset the failure flag if enough time has passed (5 minutes)
    if(printerConnectionFailed && printerErrorCount > 3) {
      const error = new Error(`Printer connection has failed multiple times. Please check printer at ${printerIp} and try again later.`);
      console.error("EPSON.printList: Too many connection failures, refusing to retry");
      throw error;
    }
    
    // Reset failure flag if we're attempting a new print (user might have fixed the issue)
    if(printerConnectionFailed) {
      console.log("Resetting printer connection failure flag for new print attempt");
      printerConnectionFailed = false;
      printerErrorCount = 0;
    }
    
    // Ensure the printer connection is open before printing
    if(epos && !epos.enabled) {
      console.log("Opening printer connection...");

      // Only (re)authenticate if we do not already have a known-good session.
      // This keeps the first print robust but makes subsequent prints fast.
      if(!isAuthenticated) {
        console.log("Authenticating before opening connection (first-time or unknown session)...");
        try {
          await EPSON.authenticate(printerIp);
          // Small delay to allow session cookie to be established
          await new Promise(resolve => setTimeout(resolve, 500));
          isAuthenticated = true;
          console.log("Authentication complete, session should be established");
        } catch(authError) {
          console.warn("Authentication warning:", authError);
          // Continue anyway - the session might still be valid from previous auth
        }
      }

      try {
        epos.open();
      } catch(openError) {
        console.error("Error opening printer connection:", openError);
        printerConnectionFailed = true;
        isAuthenticated = false;
        throw new Error(`Failed to open printer connection at ${printerIp}: ${openError.message}`);
      }
    }

    const sendOnce = () => {
      let ticket = EPSON.startTicket();
      for(let i = 0; i < list.length; i++){
        ticket.addText(list[ i ] + "\n");
      }
      ticket.addText("\n\n\n");
      ticket.addCut(ticket.CUT_FEED);   // use the epson method, NOT ours
      
      //Send the print document
      let request = ticket.toString();
      
      // Create a promise to handle async epos.send() with callbacks
      isPrinting = true;
      isPrintError = false;
      
      return new Promise((resolve, reject) => {
        // Store promise handlers for onreceive/onerror callbacks
        sendPromiseResolve = resolve;
        sendPromiseReject = reject;
        
        // Set timeout to catch cases where printer doesn't respond (connection refused, etc.)
        const timeout = setTimeout(() => {
          isPrinting = false;
          // Only reject if promise handlers are still set (not already resolved/rejected)
          if(sendPromiseReject) {
            const error = new Error(`Printer at ${printerIp} did not respond. Connection may be refused or printer is offline.`);
            console.error("EPSON.printList timeout:", error.message);
            const rejectHandler = sendPromiseReject;
            sendPromiseReject = null;
            sendPromiseResolve = null;
            rejectHandler(error);
          }
        }, 5000); // 5 second timeout for connection errors
        
        // Override resolve/reject to clear timeout
        const originalResolve = resolve;
        const originalReject = reject;
        sendPromiseResolve = () => {
          clearTimeout(timeout);
          originalResolve();
        };
        sendPromiseReject = (error) => {
          clearTimeout(timeout);
          originalReject(error);
        };
        
        try {
          epos.send(request);
        } catch(error) {
          clearTimeout(timeout);
          console.error("EPSON.printList send error:", error.message);
          const err = new Error(`Failed to send print job to printer at ${printerIp}: ${error.message}`);
          sendPromiseReject = null;
          sendPromiseResolve = null;
          originalReject(err);
        }
      });
    };

    // First attempt
    try {
      return await sendOnce();
    } catch(error) {
      const msg = (error && error.message) ? error.message.toLowerCase() : "";
      const isConnectionOrAuthError =
        msg.includes("connection error to printer") ||
        msg.includes("did not respond") ||
        msg.includes("failed to open printer connection") ||
        msg.includes("cors") ||
        msg.includes("authentication");

      if(!isConnectionOrAuthError) {
        // Non-connection error: don't retry, just propagate
        throw error;
      }

      console.warn("First print attempt failed, re-authenticating and retrying once...", error.message);

      // Reset flags and try to re-authenticate
      isAuthenticated = false;
      printerConnectionFailed = false;

      try {
        await EPSON.authenticate(printerIp);
        await new Promise(resolve => setTimeout(resolve, 500));
        isAuthenticated = true;
      } catch(authError) {
        console.warn("Retry authentication failed:", authError);
        // We'll still attempt a retry; if it fails, caller will see the error
      }

      // Ensure connection is (re)opened before retry
      if(epos && !epos.enabled) {
        console.log("Re-opening printer connection for retry...");
        try {
          epos.open();
        } catch(openError) {
          console.error("Error reopening printer connection on retry:", openError);
          throw error; // Give original error back to caller
        }
      }

      // Second (and final) attempt
      return await sendOnce();
    }
  }

  EPSON.addCut = (ticket) => {
    return ticket.addCut(ticket.CUT_FEED);
  }

  EPSON.addItems = (ticket, order) => {
    return ticket;
  }

  // Simple helpers so the app can query printer state if needed
  EPSON.isPrinterConfigured = () => {
    return printerConfigured && !!printerIp;
  }

  EPSON.isPrinterAuthenticated = () => {
    return isAuthenticated && EPSON.isPrinterConfigured();
  }

  // NOTE: this step does NOT seem to be working correctly
  EPSON.verify = async (ip) => {
    return
    // let url = "https://epson:epson@" + ip;
    // let url = "https://cors.io?https://" + ip;     // fixme: this is a hack to get around the CORS issue
    // let url = "https://" + ip;

    console.log("EPSON.verify()");

    // await this.$root.confirm( "verify printer " + ip);
    try {
      let auth = {
        username: "epson",
        password: "epson"
      }

      let ePrinter = axios.create({
                                    headers: {
                                      // 'Accept':'text/html,application/xhtml+xml,application/xml;q=0.9,image/avif,image/webp,image/apng,*/*;q=0.8,application/signed-exchange;v=b3;q=0.9',
                                      // 'Content-Type': 'application/x-www-form-urlencoded', 'Accept'      : 'application/x-www-form-urlencoded', 'Authorization' : 'Basic
                                      // ZXBzb246ZXBzb24=',
                                      'Content-Type'               : 'application/json',
                                      'Accept'                     : 'application/json',
                                      'Access-Control-Allow-Method': 'GET, POST, PUT, DELETE, OPTIONS',
                                      'Access-Control-Allow-Origin': '*'
                                    }
                                  });

      let result = await ePrinter.get(url);

      console.log("verify result", result);

      return result;

    } catch(error) {
      console.log("---------------------------------- oops, verify threw an error ", error.message);
    }
  }

  //---------------------------------------------------------------------------------------[ Cancel printing ]
  EPSON.cancel = () => {
    isPrinting = false;
  },

    EPSON.send = async (ticket) => {
      // Check if printer is initialized
      if(!epos) {
        const error = new Error("Printer not initialized. Please check printer connection.");
        console.error("EPSON.send error:", error.message);
        throw error;
      }

      var request = ticket.toString();
      try {
        await epos.send(request);     // send the document to the printer
      } catch(error) {
        console.error("EPSON.send error:", error.message);
        // Re-throw the error so the caller can handle it (e.g., show alert to user)
        throw error;
      }
    }

  //---------------------------------------------------------------------------------------[ print an order ]
  // EPSON.printReceipt = async ( order ) => {

  //   if( ! printer ) {
  //     if( ! printerIp ) {
  //       console.log( "no printer defined" );
  //       return this.$emit( "error" , "no printer defined" );
  //     }
  //     if( ! EPSON.init(printerIp)) {
  //       console.log( "unable to init printer" );
  //       return this.$emit( "error" , "unable to init printer" );
  //     }
  //   }

  //   let ticket = EPSON.startTicket();
  //   addHeader( ticket , order );
  //   addItems( ticket , order );
  //   send( ticket );

  // }

  // ticketAddOrderHeader(builder, order) {

  //   builder.addTextSize(2, 1);
  //   builder.addText(order.alias + "\n");
  //   builder.addText("\n");

  //   builder.addTextSize(1, 1);

  //   builder.addText( "ticketAddOrderHeader()")
  //   // if(order.grade.length > 0) {
  //   //   builder.addText("Grade: " + order.grade + "\n");
  //   // }
  //   // if(order.homeRoom) {
  //   //   builder.addText("Home Room: " + order.homeRoom + "\n");
  //   //   builder.addText( this.getClassDescription( order.homeRoom ) + "\n" );
  //   //   builder.addTextSize(2, 1);
  //   //   builder.addText( this.rotationLocation( order.homeRoom ) + "\n\n" );
  //   //   builder.addTextSize(1, 1);
  //   // }
  //   // builder.addText(Moment(order.orderDate).format("dddd, DD-MMM-YY") + "\n");

  //   builder.addText("\n");
  //   builder.addText("\n");

  // },
  // ticketAddOrderItems(builder, order) {
  //   builder.addTextAlign(builder.ALIGN_LEFT);
  //   builder.addTextSize(1, 1);
  //   builder.addHLine(1, 501, builder.LINE_THIN);
  //   for(var item of order.items){
  //     builder.addText(FMT.makeLineItem(item.qty, item.title, Currency(item.price).multiply(item.qty)) + "\n");
  //   }
  //   builder.addHLine(1, 501, builder.LINE_THIN);
  // },
  // ticketAddOrderBarcode(builder, order) {
  //   builder.addTextAlign(builder.ALIGN_CENTER);
  //   builder.addText("\n");
  //   builder.addBarcode(order.badgeNumber, builder.BARCODE_CODE39, builder.HRI_NONE, builder.FONT_A, 2, 64);
  //   builder.addText(order.badgeNumber + "\n");
  //   builder.addText("\n");
  // },
  // ticketAddItemCount(builder, order) {
  //   builder.addTextSize(2, 4);
  //   builder.addText(this.itemCount(order.items).toString() + " Items\n");
  //   builder.addTextSize(1, 1);
  //   builder.addText("\n");
  //   builder.addText("\n");
  // },

})();
